export function formatCurrency(num: number | string, keepTrailingZeros = false) {
  const parts = Number.parseFloat(`${num}`).toFixed(2).split('.');
  if (!parts[0]) return '0';
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (parts[1] === '00' && !keepTrailingZeros) return parts[0];
  return parts.join('.');
}

export function formatBalance(balance: number | string, options = { keepTrailingZeros: false }) {
  const value = Number.parseFloat(`${balance || 0}`) / 100;
  return formatCurrency(value, options.keepTrailingZeros);
}
